export default __webpack_public_path__ + "static/media/profile_avatar.ecadb5d3.svg";